import { Component, OnInit, inject } from '@angular/core';

import { NavigationService } from '@frontend/vanilla/core';
import { ImageComponent } from '@frontend/vanilla/shared/image';

import { ProductMenuItemBase } from './product-menu-item-base';

@Component({
    imports: [ImageComponent],
    selector: 'vn-pm-header-bar-logo',
    templateUrl: 'header-bar-logo.html',
})
export class HeaderBarLogoComponent extends ProductMenuItemBase implements OnInit {
    constructor() {
        super();
    }
    logoImage: string;
    homeUrl: string;
    logoClass: string | undefined;

    private readonly navigationService = inject(NavigationService);
    ngOnInit(): void {
        this.logoImage = this.item.image.src;
        this.logoClass = this.item.resources['image-class'] || undefined;
        this.homeUrl = this.item.url;
    }
    async goToHomeUrl() {
        if (this.homeUrl) {
            await this.navigationService.goTo(this.homeUrl);
        }
    }
}
